import { Box, Button, Fab, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { useDispatch } from 'react-redux';
import { DeletAllCompanyResponse, DeleteCompanyResponse } from '../../services/Service';
import { deleteBusiness } from '../../store/businessSlice';
import SuccessToast from '../Toast/Success';
import ErrorToast from '../Toast/Error';

const DeleteCompanyModal = ({ openDeleteModal, setOpenDelete, id, setSelected, handleActionClose }) => {
  const dispatch = useDispatch();

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    // boxShadow: 24,
  };
  const handledelete = (val) => {
    DeleteCompanyResponse(val)
      .then((res) => {
        if (res.data.success === true) {
          dispatch(deleteBusiness(val));
          setSelected([]);
          SuccessToast('Successfully Deleted');
        } else {
          ErrorToast(res.data.message);
        }
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const handleDeleteAll = (selectedIDs) => {
    console.log('selectedId', selectedIDs);
    DeletAllCompanyResponse(selectedIDs)
      .then((res) => {
        if (res.data.success === true) {
          dispatch(deleteBusiness(selectedIDs[0]));
          setSelected([]);
          SuccessToast('Succesfully deleted');
        } else {
          ErrorToast(res.data.message);
        }
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  return (
    <>
      <Modal
        hideBackdrop
        open={openDeleteModal}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: 500, height: 180 }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, mr: 1 }}>
            <Fab
              onClick={() => {
                setOpenDelete(false);
                handleActionClose();
              }}
              size="small"
              color="primary"
              aria-label="add"
            >
              <CloseIcon />
            </Fab>
          </Box>
          <Typography id="alert-dialog-title" sx={{ textAlign: 'center', fontSize: '20px', fontWeight: 500, mb: 1.5 }}>
            Do you sure want to Delete Data?
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexFlow: 'row',
              justifyContent: 'center',
            }}
          >
            <Box sx={{ display: 'flex', mt: 1 }}>
              <Button
                variant="contained"
                sx={{
                  textTransform: 'capitalize',
                }}
                onClick={(e) => {
                  e.preventDefault();
                  if (id[0].length > 1) {
                    handleDeleteAll(id);
                  } else {
                    handledelete(id);
                  }
                  setOpenDelete(false);
                  handleActionClose();
                }}
              >
                Yes
              </Button>
            </Box>

            <Box sx={{ display: 'flex', ml: 3, mt: 1 }}>
              <Button
                sx={{
                  textTransform: 'capitalize',
                }}
                variant="contained"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenDelete(false);
                  handleActionClose();
                }}
              >
                No
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteCompanyModal;
